// Platform detection utility for Capacitor / Web
// Usage: import { isNative, isIOS, isWeb, isAdminBuild } from '@/utils/platform'

import { Capacitor } from '@capacitor/core';

/** True when running inside a native Capacitor shell (iOS/Android) */
export const isNative = Capacitor.isNativePlatform();

/** True when running inside iOS (Capacitor) */
export const isIOS = Capacitor.getPlatform() === 'ios';

/** True when running inside Android (Capacitor) */
export const isAndroid = Capacitor.getPlatform() === 'android';

/** True when running in a standard web browser */
export const isWeb = !isNative;

/** True when the build is the admin TestFlight build */
export const isAdminBuild = import.meta.env.VITE_APP_TARGET === 'ios-admin';

/** True quand l'app Android vient du Play Store : c'est Play qui la met a jour,
 *  la proposition de telecharger l'APK y est interdite (politique Google). */
export const isPlayBuild = import.meta.env.VITE_APP_TARGET === 'android-play';

/** True when admin features should be shown (web always, or admin build on native) */
export const showAdmin = isWeb || isAdminBuild;

/** Open an external URL – uses @capacitor/browser on native, window.open on web */
export async function openExternalUrl(url) {
  if (!url) return;
  if (isNative) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
  } else {
    window.open(url, '_blank');
  }
}

// Apply native class to <html> for CSS safe-area helpers.
// `native-shell` porte le comportement commun aux deux plateformes (viewport
// verrouille, seul .native-scroll-container defile) : sans elle, Android
// n'aurait aucune regle de shell et le contenu passerait sous les barres fixes.
if (isNative) {
  document.documentElement.classList.add('native-shell');
}
if (isNative && isIOS) {
  document.documentElement.classList.add('native-ios');
}
if (isNative && isAndroid) {
  document.documentElement.classList.add('native-android');
}
